module.exports = __webpack_public_path__ + "img/Ilu_Notebook_logo.e562bf13.svg";